import { useContext } from "react"
import TaskReportExportContext from "../TaskReportExportContext"

const useTaskReportExportContext = () => {
  const providedValue = useContext(TaskReportExportContext)

  return { ...providedValue }
}

export default useTaskReportExportContext
